import { FC, useContext } from 'react';
import { ConfigContext, SMPFlex, SMPLinkWrapper, SMPText } from '@velinsi/smp-widgets-ui';
import SelectionModel from '@mediaplatform/sportal365-odds-utils/types/models/selection.model';
import { isMobileUserAgent } from '@sportal365/smp-widget-utils';
import { DESKTOP, MOBILE } from '../../../../../packages/constants/deviceTypes';

interface Props {
  selections: SelectionModel[];
  addTopDistance?: boolean;
  handleClick?: (link: string) => void;
}

const BettingRow: FC<Props> = ({ selections, addTopDistance, handleClick }) => {
  const { dataOddsClickable } = useContext(ConfigContext);

  const getSelectionUrl = (selection: SelectionModel) => {
    if (!selection.urls || !selection.urls.length || !dataOddsClickable) {
      return undefined;
    }

    return (
      selection.urls?.find(({ appType }) => appType === (isMobileUserAgent() ? MOBILE : DESKTOP))?.url ??
      selection.urls?.[0].url ??
      undefined
    );
  };

  return (
    <SMPFlex justify={'center'} align={'center'} gap={'sm'} css={{ width: '100%', marginTop: addTopDistance ? '$1' : '' }}>
      {selections.map((selection, index) => {
        const selectionUrl = getSelectionUrl(selection);
        return (
          <SMPLinkWrapper
            target='_blank'
            href={selectionUrl}
            key={`betting-row-${selection.code}-${selection.odds} -${index}`}
            onClick={(e) => {
              if (dataOddsClickable === false) {
                e.preventDefault();
                return;
              }

              handleClick && selectionUrl && handleClick(selectionUrl);
            }}
          >
            <SMPFlex
              align={'center'}
              justify={'center'}
              gap={'sm'}
              style={{ width: '100%' }}
              css={{
                py: '3px',
                backgroundColor: '$pillBackgroundColor',
                borderRadius: '$1',
                minWidth: '47px',
              }}
            >
              <SMPText size={'2'} css={{ lineHeight: '18px', color: '$selectButtonSecondaryColor' }}>
                {selection.code ? selection.code : ''}
              </SMPText>
              <SMPText size={'2_5'} css={{ lineHeight: '20px', color: '$hiContrast' }}>
                {selection.odds ?? '-'}
              </SMPText>
            </SMPFlex>
          </SMPLinkWrapper>
        );
      })}
    </SMPFlex>
  );
};

export default BettingRow;
